<template>
   <div class="change-item-details-c">
      <template v-if="task.newSegments?.length != 0">
         <div class="change-table-header-wrapper">
            {{ $t("changeHistory_lblHistory") }}
         </div>
         <ChangeHistory :rows="task.oldSegments" oldsegments />
      </template>

      <template v-if="task.newSegments?.length != 0">
         <div class="change-table-header-wrapper">
            {{ $t("changeHistory_lblLatestEntry") }}
         </div>
         <ChangeHistory :rows="task.newSegments" />
      </template>

      <template v-if="task.subStatus != 6">
         <ChangeApprove :message="flightMessage" :subType="task.subType" :taskId="task.id" :action="actionDetails" />
      </template>
   </div>
</template>

<script>
import ChangeHistory from "./ChangeHistory.vue";
import ChangeApprove from "./ChangeApprove.vue";
export default {
   name: "ChangeItemDetails",
   props: {
      task: Object,
   },
   components: {
      ChangeHistory,
      ChangeApprove,
   },
   data() {
      return {
         flightMessage: {
            greeting: this.$i18n.t(`changeItemDetails_lblGreeting`),
            body: this.$i18n.t(`changeItemDetails_lblBody`),
            details: this.task.changes,
            closing: this.$i18n.t(`changeItemDetails_lblClosing`),
         },
         actionDetails: {
            label: "Approve",
         },
      };
   },
};
</script>

<style lang="scss" scoped>
.change-item-details-c {
   // margin: 1.25rem 1rem;

   .change-table-header-wrapper {
      font-weight: 500 !important;
      font-size: 1.125rem;
   }
}
</style>
